import React, { useEffect } from "react";
import { toast } from "react-toastify";
import TV from "../Tv/TvList";
import { useSelector, useDispatch } from "react-redux";
import {
  user_Authenticated,
  user_Not_Authenticated,
  selectisAuthenticated,
} from "../../features/auth/authSlice";

import { useNavigate } from "react-router-dom";
import PatientelleGrid from "../Patientelle/PatientelleGrid";
import logoutPNG from "../image/Logout.png";
import PriseEnChargeLITE from "../PriseEnCharge/PriseEnChargeLITE"

const Dashboard = () => {
  const Auth = useSelector(selectisAuthenticated);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const getProfile = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_SERVER}dashboard`, {
        method: "GET",
        headers: { jwtoken: sessionStorage.token },
      });

      const parseData = await res.json();
      dispatch(user_Authenticated(parseData));
    } catch (err) {
      console.error(err.message);
    }
  };

  const logout = async (e) => {
    e.preventDefault();
    try {
      sessionStorage.removeItem("token");
      dispatch(user_Not_Authenticated());
      navigate("/login");
      toast.success("Logout successfully");
    } catch (err) {
      console.error(err.message);
    }
  };
  useEffect(() => {
    getProfile();
    // eslint-disable-next-line
  }, []);
  if (Auth.role === "tv") {
    return <TV logout={logout} />;
  } else if (Auth.role === "clinique") {
    return <PriseEnChargeLITE />;
  }
  else if (Auth.role === "admin") {
    return <PatientelleGrid />;
  } else if (Auth.role === null) {
    return <PatientelleGrid />;
  } else {
    return (
      <div className="divLoader">
        <svg
          className="svgLoader"
          viewBox="0 0 100 100"
          width="10em"
          height="10em"
        >
          <path
            ng-attr-d="{{config.pathCmd}}"
            ng-attr-fill="{{config.color}}"
            stroke="none"
            d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50"
            fill="#51CACC"
            transform="rotate(179.719 50 51)"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              calcMode="linear"
              values="0 50 51;360 50 51"
              keyTimes="0;1"
              dur="1s"
              begin="0s"
              repeatCount="indefinite"
            ></animateTransform>
          </path>
        </svg>
        <button className="foreground" onClick={(e) => logout(e)}>
          <img className="logo2" src={logoutPNG} alt="logout" />
        </button>
      </div>
    );
  }
};

export default Dashboard;
